import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("rosalvo_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || "Erro inesperado";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join(" ");
  }
  if (typeof detail === "object" && detail.msg) return detail.msg;
  return String(detail);
}

/* Site constants (editable here) */
export const SITE = {
  name: "Antônio Rosalvo",
  slogan: "Homem que honra sua palavra",
  party: "PSDB",
  city: "Lauro de Freitas, Bahia",
  whatsapp: "5571992310448",
  whatsappDisplay: "(71) 99231-0448",
  instagram: "https://www.instagram.com/rosalvo_oficial/",
  instagramHandle: "@rosalvo_oficial",
  facebook: "https://www.facebook.com/antoniorosalvo",
  email: "contato@antoniorosalvo.com.br",
  domain: "www.antoniorosalvo.com.br",

  // Site em modo "reconstrução": exibe apenas QR Code apontando pro Instagram.
  // Admin (/admin/login e /admin) continua acessível normalmente.
  // Para reativar o site completo, mude para false e republique.
  maintenanceMode: true,
};
